module.exports = __webpack_public_path__ + "static/media/terms-and-conditions.255d6e2a.md";